/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_ErrorsInputs */

const en_editor_filter_errors = /** @type {(inputs: Editor_Filter_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errors`)
};

const fr_editor_filter_errors = /** @type {(inputs: Editor_Filter_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreurs`)
};

const de_editor_filter_errors = /** @type {(inputs: Editor_Filter_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler`)
};

const it_editor_filter_errors = /** @type {(inputs: Editor_Filter_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errori`)
};

const ru_editor_filter_errors = /** @type {(inputs: Editor_Filter_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибки`)
};

const es_editor_filter_errors = /** @type {(inputs: Editor_Filter_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errores`)
};

const zh_cn2_editor_filter_errors = /** @type {(inputs: Editor_Filter_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误`)
};

const ja_editor_filter_errors = /** @type {(inputs: Editor_Filter_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー`)
};

const hi_editor_filter_errors = /** @type {(inputs: Editor_Filter_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटियाँ`)
};

const pt_pt2_editor_filter_errors = /** @type {(inputs: Editor_Filter_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erros`)
};

/**
* | output |
* | --- |
* | "Errors" |
*
* @param {Editor_Filter_ErrorsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_errors = /** @type {((inputs?: Editor_Filter_ErrorsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_ErrorsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_filter_errors(inputs)
	if (locale === "de") return de_editor_filter_errors(inputs)
	if (locale === "it") return it_editor_filter_errors(inputs)
	if (locale === "ru") return ru_editor_filter_errors(inputs)
	if (locale === "es") return es_editor_filter_errors(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_filter_errors(inputs)
	if (locale === "ja") return ja_editor_filter_errors(inputs)
	if (locale === "hi") return hi_editor_filter_errors(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_filter_errors(inputs)
	return en_editor_filter_errors(inputs)
});